export default {
  // Generic
  'generic.add': 'Ok',
  'generic.cancel': 'Cancelar',

  // BlockType
  'components.controls.blocktype.h1': 'Título 1',
  'components.controls.blocktype.h2': 'Título 2',
  'components.controls.blocktype.h3': 'Título 3',
  'components.controls.blocktype.h4': 'Título 4',
  'components.controls.blocktype.h5': 'Título 5',
  'components.controls.blocktype.h6': 'Título 6',
  'components.controls.blocktype.blockquote': 'Citação',
  'components.controls.blocktype.code': 'Code',
  'components.controls.blocktype.blocktype': 'Estilo',
  'components.controls.blocktype.normal': 'Normal',

  // Color Picker
  'components.controls.colorpicker.colorpicker': 'Paleta de cores',
  'components.controls.colorpicker.text': 'Texto',
  'components.controls.colorpicker.background': 'Fundo',

  // Embedded
  'components.controls.embedded.embedded': 'Embarcado',
  'components.controls.embedded.embeddedlink': 'Link embarcado',
  'components.controls.embedded.enterlink': 'Coloque o link',

  // Emoji
  'components.controls.emoji.emoji': 'Emoji',

  // FontFamily
  'components.controls.fontfamily.fontfamily': 'Fonte',

  // FontSize
  'components.controls.fontsize.fontsize': 'Tamanho da Fonte',

  // History
  'components.controls.history.history': 'Histórico',
  'components.controls.history.undo': 'Desfazer',
  'components.controls.history.redo': 'Refazer',

  // Image
  'components.controls.image.image': 'Imagem',
  'components.controls.image.fileUpload': 'Carregar arquivo',
  'components.controls.image.byURL': 'URL',
  'components.controls.image.dropFileText':
    'Arraste uma imagem aqui ou clique para carregar',

  // Inline
  'components.controls.inline.bold': 'Negrito',
  'components.controls.inline.italic': 'Itálico',
  'components.controls.inline.underline': 'Sublinhado',
  'components.controls.inline.strikethrough': 'Strikethrough',
  'components.controls.inline.monospace': 'Monospace',
  'components.controls.inline.superscript': 'Sobrescrito',
  'components.controls.inline.subscript': 'Subscrito',

  // Link
  'components.controls.link.linkTitle': 'Título do link',
  'components.controls.link.linkTarget': 'Alvo do link',
  'components.controls.link.linkTargetOption': 'Abrir link em outra janela',
  'components.controls.link.link': 'Adicionar Link',
  'components.controls.link.unlink': 'Remover link',

  // List
  'components.controls.list.list': 'Lista',
  'components.controls.list.unordered': 'Sem ordenção',
  'components.controls.list.ordered': 'Ordenada',
  'components.controls.list.indent': 'Aumentar recuo',
  'components.controls.list.outdent': 'Diminuir recuo',

  // Remove
  'components.controls.remove.remove': 'Remover',

  // TextAlign
  'components.controls.textalign.textalign': 'Alinhamento do texto',
  'components.controls.textalign.left': 'À Esquerda',
  'components.controls.textalign.center': 'Centralizado',
  'components.controls.textalign.right': 'À Direita',
  'components.controls.textalign.justify': 'Justificado',

  // New Examod localizations
  'components.controls.image.modal.title': 'Image Uploader',
  'components.controls.image.modal.description':
    'Browse or drag the image you want to upload',
  'components.controls.image.modal.content.image.or': 'or',
  'components.controls.image.modal.content.image.btn': 'Browse Files',
  'components.controls.image.modal.content.image.attachment':
    'Attachments should not exceed 2 mb',
  'components.controls.image.modal.content.image.supported':
    'Supported file types: JPEG, JPG, PNG',
  'components.controls.image.modal.content.input.alt.label': 'Alt Text',
  'components.controls.image.modal.content.input.alt.placeholder':
    'Image alt text',
  'components.controls.image.modal.content.input.scale.label': 'Scale (%)',
  'components.controls.image.modal.contnet.url.address.label': '*URL (Adress)',
  'components.controls.image.modal.link.title': 'URL',
  'components.controls.image.modal.link.description': 'Add image from address',

  // New Highlight Colors 'Clear Highlight'
  'components.controls.color.picker.highlight.clear': 'Clear Highlight',
  'components.controls.color.picker.highlight.black': 'Black Highlight',
  'components.controls.color.picker.highlight.grey': 'Grey Highlight',
  'components.controls.color.picker.highlight.red': 'Red Highlight',
  'components.controls.color.picker.highlight.green': 'Green Highlight',
  'components.controls.color.picker.highlight.blue': 'Blue Highlight',
  'components.controls.color.picker.highlight.yellow': 'Yellow Highlight',
  'components.controls.color.picker.highlight.examod': 'Examod Highlight',
  'components.controls.color.picker.highlight.purple': 'Purple Highlight',
  'components.controls.color.picker.highlight.pink': 'Pink Highlight',
};
